import { ElementType, HTMLAttributes } from 'react';

interface CmsProps extends HTMLAttributes<HTMLElement> {
    content?: string;
    as?: ElementType;
}

export function Cms({ content = '', as: Component = 'div', ...props }: CmsProps) {
    return <Component dangerouslySetInnerHTML={{ __html: content }} {...props} />;
}
